import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d800220e")

_pushScopeId("data-v-d800220e")
const _hoisted_1 = { class: "border-gray-lp-1400 border rounded-xl" }
const _hoisted_2 = { class: "items-center mb-1 p-3 border-b" }
const _hoisted_3 = { class: "text-gray-lp-300 text-20px font-bold" }
const _hoisted_4 = { class: "text-14px font-normal font-montserrat text-gray-lp-600" }
const _hoisted_5 = { class: "w-full mt-2 flex gap-4 p-3" }
const _hoisted_6 = { class: "flex flex-row justify-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DateTimeInputField = _resolveComponent("DateTimeInputField")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock(_component_ModalV2, {
    width: "w-15/20",
    title: "Ubah periode harga",
    onClose: () => _ctx.onHidePopup(),
    scrollable: false,
    isRounded: "",
    titlePadding: "px-6 py-3",
    contentPadding: "px-3 py-3",
    footerPadding: "px-6 py-3"
  }, {
    content: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("clientManagement.changePeriodModal.periodPrice")), 1),
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("clientManagement.changePeriodModal.selectDateRangeDesc")), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('clientManagement.changePeriodModal.dateAndTimeStart'),
            class: "w-6/12",
            required: "",
            asterisk: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_DateTimeInputField, {
                class: "my-2",
                modelValue: _ctx.startDatePeriod,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.startDatePeriod = $event)),
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue.priceRateStartDate = $event))
                ],
                title: _ctx.$t('clientManagement.changePeriodModal.dateAndTimeStart'),
                placeholder: _ctx.$t('clientManagement.changePeriodModal.selectDateAndTime'),
                disabled: "",
                minDate: new Date(new Date().setDate(new Date().getDate() + 1))
              }, null, 8, ["modelValue", "title", "placeholder", "minDate"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('clientManagement.changePeriodModal.dateAndTimeEnd'),
            class: "w-6/12",
            required: "",
            asterisk: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_DateTimeInputField, {
                class: "my-2",
                modelValue: _ctx.endDate,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => (_ctx.endDate = $event)),
                  _cache[4] || (_cache[4] = ($event: any) => (_ctx.endDate = $event))
                ],
                title: _ctx.$t('clientManagement.changePeriodModal.dateAndTimeEnd'),
                placeholder: _ctx.$t('clientManagement.changePeriodModal.selectDateAndTime'),
                minDate: _ctx.minDate
              }, null, 8, ["modelValue", "title", "placeholder", "minDate"])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ])
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_LpButton, {
          title: "Simpan",
          textColor: "white",
          disabled: !_ctx.endDate,
          onClick: _ctx.onSubmit,
          customClass: "px-4 py-2"
        }, null, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})